<template>
  <NuxtPicture
    :alt="alt"
    :quality="quality"
    :sizes="sizes"
    :height="height"
    :width="width"
    provider="snipes"
    densities="x1"
    :src="computedImage"
    :loading="imageLoading"
    :preload="preload"
    :class="{
      'picture-contain': fit === 'contain',
      'picture-cover': fit === 'cover',
      'm-auto h-[90%]': isCentered,
      'mix-blend-darken': withMixBlendDarken,
    }"
    data-testid="product-image"
    class="picture block"
    @load="load"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ProductImage } from '@scayle/storefront-nuxt'
import { NuxtPicture } from '#components'

const {
  sizes = '',
  isCentered = false,
  withMixBlendDarken = true,
  fit = 'contain',
  imageLoading = 'eager',
  preload = false,
  quality = 75,
  load = () => {},
  image,
} = defineProps<{
  image: ProductImage | string
  sizes?: string
  fit?: 'contain' | 'cover'
  alt: string
  imageLoading?: 'lazy' | 'eager'
  preload?: boolean
  quality?: number
  load?: () => void
  isCentered?: boolean
  withMixBlendDarken?: boolean
  height?: number | string
  width?: number | string
}>()

const computedImage = computed(() =>
  typeof image === 'string' ? image : image.hash,
)
</script>

<!-- Styles for .picture classes are in assets/css/main.css -->
